/** A station's logo as a small rounded tile. Decorative: the station name is always printed next to it. */
export function StationLogo({ slug, size = 36 }: { slug: string; size?: number }) {
  return (
    <img className="station-logo" src={`/stations/${slug}.png`} alt="" width={size} height={size} loading="lazy"
      onError={(e) => { e.currentTarget.style.display = "none"; }} />
  );
}
